export default __webpack_public_path__ + "static/media/user2.21c00a6b.svg";